import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './lib/contact-click.ts';

const rootElement = document.getElementById('root')!;

// If the page was prerendered, hydrate instead of creating a new root.
// This preserves the server-rendered HTML and makes it interactive.
if (rootElement.hasChildNodes() && rootElement.dataset.prerendered) {
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
